/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quickcreatewithai3Inputs */

const en_quickcreatewithai3 = /** @type {(inputs: Quickcreatewithai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create with AI`)
};

const de_quickcreatewithai3 = /** @type {(inputs: Quickcreatewithai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit KI erstellen`)
};

/**
* | output |
* | --- |
* | "Create with AI" |
*
* @param {Quickcreatewithai3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const quickcreatewithai3 = /** @type {((inputs?: Quickcreatewithai3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickcreatewithai3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quickcreatewithai3(inputs)
	return de_quickcreatewithai3(inputs)
});
export { quickcreatewithai3 as "quickCreateWithAi" }